import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect } from "react";

import API_Calls_Dashboard from "@/api/calls/political/API_Calls_Dashboard";
import Notifications from "@/components/Notifications/Notifications";
import VolunteerDataTableContainer from "@/components/political/Dashboard/VolunteerDataTableContainer";

function Dashboard() {
  const [dashboardFiles, setDashboardFiles] = useState([]);
  const [notification, setNotification] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const { getDashboard } = API_Calls_Dashboard();
  const { user } = useAuth0();

  useEffect(() => {
    if (user?.org_name) {
      fetchDashboardFiles();
    }
    // fetchDashboardFiles is an inline function recreated each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const fetchDashboardFiles = async () => {
    const res = await getDashboard(user.org_name);
    if (!res.error && res.data) {
      setDashboardFiles(res.data.files);
    } else {
      setNotification({
        message: "There was an error fetching this dashboard.",
        severity: "error",
        messageDuration: 7000,
      });
      console.error("Error fetching dashboard: ", res);
    }
    setIsLoading(false);
  };

  return (
    <>
      <VolunteerDataTableContainer
        files={dashboardFiles}
        isLoading={isLoading}
      />

      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </>
  );
}

export default Dashboard;
